import { MfaPromptComponent } from '@/features/auth';

export default function Verify2faPage() {
  return <MfaPromptComponent />;
}
